import { BOUNDING_BOX } from "../../constants";

export const EMPTY_IDS: string[] = [];

export const boxStyle = {
  position: "absolute" as const,
  left: 0,
  top: 0,
  borderWidth: BOUNDING_BOX.STROKE_WIDTH,
  borderRadius: BOUNDING_BOX.CORNER_RADIUS,
  pointerEvents: "auto" as const,
  cursor: "pointer" as const,
  boxSizing: "border-box" as const,
  borderStyle: "solid" as const,
  borderColor: BOUNDING_BOX.STROKE_COLOR,
  backgroundColor: BOUNDING_BOX.FILL_COLOR,
};

export const pointStyle = {
  size: 10,
  hitPadding: 6,
  fill: BOUNDING_BOX.FILL_COLOR,
  border: BOUNDING_BOX.STROKE_COLOR,
  borderWidth: 2,
  borderStyle: "solid" as const,
};

export const polygonStyle = {
  fill: BOUNDING_BOX.FILL_COLOR,
  stroke: BOUNDING_BOX.STROKE_COLOR,
  strokeWidth: BOUNDING_BOX.STROKE_WIDTH,
};
